module.exports = __webpack_public_path__ + "img/hero-renegades-le_woodsy.a4e0108.jpeg";